import { render, staticRenderFns } from "./Game_a_type.vue?vue&type=template&id=39a058d9&style=true"
import script from "./Game_a_type.vue?vue&type=script&lang=js"
export * from "./Game_a_type.vue?vue&type=script&lang=js"
import style0 from "./Game_a_type.vue?vue&type=style&index=0&id=39a058d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports